<template>
	<HeaderBlock title="Notifications" />
	<CustomerLoadWait :customer="customer" />
	<transition>
		<div v-if="customer" class="notifications-page">

			<!-- Daily balance update -->
			<div class="notif-section">
				<div class="notif-section-title">Daily balance update</div>
				<div class="notif-card">
					<span class="notif-label">Current Accounts</span>
					<MGToggle
						v-model="customer.preferences.dailyCurrentBalanceNotifications"
						@update:modelValue="savePrefs"
					/>
				</div>
				<div class="notif-card">
					<span class="notif-label">Credit Cards</span>
					<MGToggle
						v-model="customer.preferences.dailyCreditBalanceNotifications"
						@update:modelValue="savePrefs"
					/>
				</div>
				<div class="notif-description">Keep on top of your spending. We'll send you a summary each morning of your balances.</div>
			</div>

			<!-- Quiz notifications -->
			<div class="notif-section">
				<div class="notif-section-title">Other notifications</div>
				<div class="notif-card">
					<span class="notif-label">Quiz updates and reminders</span>
					<MGToggle
						v-model="customer.preferences.quizNotifications"
						@update:modelValue="savePrefs"
					/>
				</div>
			</div>

		</div>
	</transition>
</template>

<script>
import Services from '../mixins/Services';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGToggle from './elements/MGToggle.vue';

export default {
	name: 'NotificationsPage',
	mixins: [Services],
	components: { CustomerLoadWait, HeaderBlock, MGToggle },
	methods: {
		getCustomer() {
			this._getCustomer(() => {
				if (this.customer.preferences == null) {
					this.customer.preferences = { dailyCurrentBalanceNotifications: false, dailyCreditBalanceNotifications: false, quizNotifications: false };
				}
			});
		},
		savePrefs() {
			this._savePreferences(() => {
				if (this.customer.preferences == null) {
					this.customer.preferences = { dailyCurrentBalanceNotifications: false, dailyCreditBalanceNotifications: false, quizNotifications: false };
				}
			});
		},
		onLoad() {
			this.getCustomer();
		}
	},
	mounted() {
		this.onLoad();
	}
}
</script>

<style scoped>
.notifications-page {
	display: flex;
	flex-direction: column;
	gap: 32px;
	padding-bottom: 32px;
}

.notif-section {
	display: flex;
	flex-direction: column;
	gap: 8px;
}

.notif-section-title {
	font-size: 16px;
	font-weight: bold;
	color: var(--text-color);
	margin-bottom: 8px;
}

.notif-card {
	display: flex;
	justify-content: space-between;
	align-items: center;
	background: rgba(255, 255, 255, 0.9);
	border-radius: 8px;
	padding: 10px 16px;
}

.notif-label {
	font-size: 13px;
	color: var(--text-color);
}

.notif-description {
	font-size: 13px;
	color: var(--text-color);
}


</style>
